<script context="module">
    export const name = "small view vertical";
</script>

<script lang="ts">
    import Data from "@reperio-news/core.components/blocks/ContentItem/Data";
    import { stripTags } from "@reperio-news/core.components/includes/Helpers";
    import { z } from "zod";
    import { getContext } from "svelte";
    type Data = z.infer<typeof Data>;
    import ImageView from "@reperio-news/core.components/ImageView.svelte";
    import { slugToColor } from "../TopMenu/View.svelte";

    const context: SvelteStore<any> = getContext("context");
    const c = getContext("parentBlockColumnCount");

    let categoryColor = "red";

    $: if (data && data.content) {
        categoryColor = slugToColor(
            data.content.category?.slug,
            $context.global_blocks?.TopMenu_main_menu?.data?.item
        );
    }

    export let data: Data;
</script>

{#if data && data.content}
    <div class="item-vertical co-{$c}">
        <div class="main">
            {#if data.content.poster}
                <a class="image" href={data.content.url}>
                    <ImageView
                        src={data.content.poster}
                        crop={data.content.poster.crop}
                        width={140}
                        height={90}
                        fit="cover"
                    />
                </a>
            {/if}
            <a
                class="title"
                href={data.content.url}
                title={stripTags(data.content.summary)}
                >{@html stripTags(data.content.title, ["i", "b", "strong", "font"])}</a
            >
        </div>
    </div>
{/if}

<style lang="scss">
    .item-vertical:hover {
        opacity: 0.9;
    }

    .item-vertical {
        min-width: 140px;
        width: 140px;
        margin-bottom: 10px;
        margin-right: 5px;
        overflow: hidden;
        padding: 5px;

        color: #000;
        padding-bottom: 5px;
        border-top: 1px solid #eee;
        border-bottom: 1px solid #eee;
        position: relative;
        background-color: #fff;

        .main {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            width: 100%;

            .image {
                width: 140px;
                height: 90px;
                overflow: hidden;
                margin-bottom: 10px;
            }

            a.title {
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                text-overflow: hidden;
                white-space: normal;
                text-overflow: ellipsis;
                font-family: "Source Sans Pro", sans-serif;
                font-style: normal;
                letter-spacing: 0.25px;
                font-weight: 600;
                font-size: 0.85rem;
            }
        }
    }

    :global {
        .carousel-news {
            div.item-vertical {
                min-width: calc((var(--parent-width) / 7) - 15px) !important;
                width: calc((var(--parent-width) / 7) - 15px) !important;
            }
        }
    }

    @media only screen and (max-width: 1000px) {
        :global {
            .carousel-news {
                div.item-vertical {
                    min-width: calc(
                        (var(--parent-width) / 6) - 15px
                    ) !important;
                    width: calc((var(--parent-width) / 6) - 15px) !important;
                }
            }
        }
    }

    @media only screen and (max-width: 600px) {
        :global {
            .carousel-news {
                div.item-vertical {
                    min-width: calc(
                        (var(--parent-width) / 3) - 15px
                    ) !important;
                    width: calc((var(--parent-width) / 3) - 15px) !important;
                }
            }
        }
    }
</style>
